import { Avatar, Box, Stack, Typography } from "@mui/material";
import { green } from "@mui/material/colors";

import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import SocialDistanceIcon from "@mui/icons-material/SocialDistance";
import EngineeringIcon from "@mui/icons-material/Engineering";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { CounterMetricCardLoader } from "../../common-ui/loaders/CouterMetricCardLoader";

type MetricType =
  | "users"
  | "assets"
  | "distribution"
  | "assignments"
  | "maintenance";

export const CounterMetricCard = ({
  title,
  value,
  type,
}: {
  title: string;
  value?: string;
  type?: MetricType;
}) => {
  const getIcon = () => {
    switch (type) {
      case "assets":
        return <CorporateFareIcon sx={styles.icon} fontSize="small" />;
      case "distribution":
        return <SocialDistanceIcon sx={styles.icon} fontSize="small" />;
      case "users":
        return <PeopleAltIcon sx={styles.icon} fontSize="small" />;
      case "maintenance":
        return <EngineeringIcon sx={styles.icon} fontSize="small" />;
      case "assignments":
        return <AssignmentIndIcon sx={styles.icon} fontSize="small" />;
      default:
        return <ShowChartIcon sx={styles.icon} fontSize="small" />;
    }
  };
  if(!value){
    return <CounterMetricCardLoader/>
  }

  return (
    <Box sx={styles.container}>
      <Stack height={120} direction="column" spacing={2} alignItems="center" py={1}>
        <Box width="100%">
          <Box sx={styles.iconWrapper}>
            <Avatar sx={styles.avatar}>{getIcon()}</Avatar>
          </Box>
          <Stack width={'100%'} justifyContent={"center"} direction={"row"} > <Typography sx={styles.title}>{title}</Typography></Stack>
       
        </Box>

        <Typography sx={styles.value}>{value}</Typography>
      </Stack>
    </Box>
  );
};

const styles = {
  container: {
    width: 280,
    height: 150,
    boxShadow:
      "rgba(0, 0, 0, 0.02) 0px 2px 4px, rgba(0, 0, 0, 0.1) 0px 7px 13px -3px, rgba(102, 187, 106, 1) 0px 0px 0px inset",
    borderRadius: 2,
    transition: "all 0.1s ease-in-out",
    cursor: "pointer",

    "&:hover": {
      transform: "translateY(-2px) scale(1.01)", 
      boxShadow:
        "rgba(0, 0, 0, 0.1) 0px 4px 8px, rgba(0, 0, 0, 0.2) 0px 8px 16px -3px, rgba(102, 187, 106, 1) 0px 2px 0px inset",
    },
  },
  iconWrapper: {
    position: "absolute",
  },
  avatar: {
    ml: 1,
    width: 30,
    height: 30,
    backgroundColor: "transparent",
    boxShadow:
      "rgba(17, 17, 26, 0.08) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
  },
  icon: {
    color: green[800],
  },
  title: {
    maxWidth:200,
    height:40,


    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 500,
    noWrap: true,
    textAlign: "center" as const,
    pt: 0.5,
  },
  value: {
    fontFamily: "Inter",
    fontSize: 40,
    fontWeight: 700,
    noWrap: true,
    textAlign: "center" as const,
  },
};
